import * as React from 'react';
import { AppContext } from '../AppContext';
import { Loading } from '../Loading';
import { ForbiddenPage } from '../pages/ForbiddenPage';

interface RequireAuthorityProps {
  /** 子要素を表示するのに必要な権限の段階（components/AuthorityLabel.tsxのAuthority） */
  level: number;
}

/**
 * 利用者の権限の段階がlevel以上のときだけ子要素を表示し、足りないときはForbiddenPageを表示する。
 * 判定はAuthButtonと同じく、AppContextのme.authority.levelとの大小比較で行う。
 */
export const RequireAuthority: React.FC<RequireAuthorityProps> = function (props) {
  const appContext = React.useContext(AppContext);
  const me = appContext.state.me;

  if (!me) {
    return <Loading />;
  }

  if (me.authority.level < props.level) {
    return <ForbiddenPage />;
  }

  return <>{props.children}</>;
};
